import InfoIcon from 'Assets/images/commons/warning.svg';
import React from 'react';
import { Flex, Alert } from 'antd';

import css from './Prescription.less';

interface WarningMessageProps {
  message: string;
}

const WarningMessage: React.FC<WarningMessageProps> = ({ message }) => {
  return (
    <Alert
      type="warning"
      showIcon={false}
      className={css.warning}
      message={
        <Flex gap={12}>
          <img src={InfoIcon} alt="" style={{ width: 24, height: 24 }} />
          <div>{message}</div>
        </Flex>
      }
    />
  );
};

export default WarningMessage;
